import { accessRole } from "../../../../helpers/access_role"
import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import { Link, useLocation } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"

import TableActiveComponent from './Components/TableActiveComponent'
import TableInactiveComponent from './Components/TableInactiveComponent'

const IndexView = (props) => {

    const [activeTab, setActiveTab] = useState("1")
    const activeRef = useRef()
    const inactiveRef = useRef()

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    const location = useLocation().pathname

    function toggle(tab) {
        if (activeTab !== tab) {
            setActiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col className="col-12">
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        // <Link to="/pengaturan/menu.html?create">
                                        <Link to={location+'?create'}>
                                            <Button color="primary">Buat Menu</Button>
                                        </Link>
                                    : null
                                }
                                </div>
                                <CardTitle>Menu</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Menu
                                </CardSubtitle>
                                <hr />
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                            <span className="d-none d-sm-block">Aktif</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                            active: activeTab === "2",
                                                })}
                                            onClick={() => {
                                                toggle("2")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Tidak Aktif</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "3",
                                            })}
                                            onClick={() => {
                                                toggle("3")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                            <span className="d-none d-sm-block">Akses</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab} className="p-3 text-muted">
                                    <TabPane tabId="1">
                                        <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <TableInactiveComponent ref={inactiveRef} handleActiveSuccess={reloadActiveRef}/>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        Akses:
                                        <div className="button-items">
                                            <Button disabled={!accessRole('create')} color="primary" className="btn btn-sm btn-info waves-effect waves-light">Create</Button>
                                            <Button disabled={!accessRole('read')} color="primary" className="btn btn-sm btn-info waves-effect waves-light">Read</Button>
                                            <Button disabled={!accessRole('update')} color="primary" className="btn btn-sm btn-info waves-effect waves-light">Update</Button>
                                            <Button disabled={!accessRole('delete')} color="primary" className="btn btn-sm btn-info waves-effect waves-light">Delete</Button>
                                            <Button disabled={!accessRole('approve')} color="primary" className="btn btn-sm btn-info waves-effect waves-light">Approve</Button>
                                            <Button disabled={!accessRole('print')} color="primary" className="btn btn-sm btn-info waves-effect waves-light">Print</Button>
                                        </div>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </Fragment>
    )

}

export default IndexView